import React, { useState } from "react"
import Header from "components/Header/Header"
import { Container, Row } from "react-bootstrap"
import AppButton from "components/StyledComponents/AppButton"
import settings from "assets/icons/settings.png"
import { Link } from "@mui/material"
import FieldsModal from "./components/FieldsModal"

function DynamicForms() {
  const [openModal, setOpenModal] = useState(false)
  const handleCloseModal = () => {
    setOpenModal(false)
  }
  const handleOpenModal = () => {
    setOpenModal(true)
  }

  return (
    <Container fluid className="p-0">
      <Row>
        <Header title="Marketing Dashboard" back={false}>
          <Link to="/marketing/dashboard/contest-configuration">
            <AppButton styles={{ marginRight: "15px" }} onClick={handleOpenModal}>
              <img src={settings} style={{ marginRight: "10px" }} />
              Dynamic Forms
            </AppButton>
          </Link>
        </Header>
      </Row>

      <FieldsModal open={openModal} onClose={handleCloseModal} />
    </Container>
  )
}

export default DynamicForms
